import React from "react";
import { bool, func, array, string } from "prop-types";

import Notifications from "../Notifications";
import Icon from "../../../icons";
import AuthView from "../../../rows/AuthView";

import "./uniformHeader.m.css";

const LoginContainer = ({
  dot,
  toggleNotifications,
  showNotifications,
  notifications,
  showLogin,
  loginBorderStyle,
  loginTextStyle,
  bellIconStyle,
  showNotification,
}) => (
  <>
    {showNotification && (
      <div styleName={`bell-container ${dot ? "new-notifications-data" : "no-notifications"}`}>
        <span styleName="bell" onClick={toggleNotifications}>
          {" "}
          <Icon
            type="bell"
            className="bell"
            iconStyle={{ fill: bellIconStyle }}
            datatrackingcategory="Button"
            datatrackingaction="Click"
            datatrackinglabel="নোটিফিকেশন বাটন"
          />
        </span>
        {showNotifications && (
          <Notifications
            closeView={toggleNotifications}
            notifications={notifications}
            toggleNotifications={toggleNotifications}
          />
        )}
      </div>
    )}
    {showLogin && <AuthView borderColor={loginBorderStyle} textColor={loginTextStyle} />}
  </>
);

LoginContainer.propTypes = {
  dot: bool,
  toggleNotifications: func,
  showNotifications: bool,
  notifications: array,
  showLogin: bool,
  loginBorderStyle: string,
  loginTextStyle: string,
  bellIconStyle: string,
  showNotification: bool,
};

export default LoginContainer;
